const messages = {
  reloadWebPage:
    'Es ist eine neue Version der App vorhanden. Klicke hier, um diese zu laden',
}

export default messages
